import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShiftSettingRegionEntity } from '../../domain/entities/ShiftSettinfRegionEntity'
export class ShiftSettingRegionModel extends ShiftSettingRegionEntity {
  regionId?: number
  regionName?: string | null
  constructor(dataDto: ShiftSettingRegionModel) {
    super()
    mapEntityProperties<ShiftSettingRegionModel>(this, dataDto, {
      exclude: ['regionId', 'regionName'],
      map: {
        region: {
          id: dataDto.regionId,
          name: dataDto.regionName
        }
      }
    })
  }
}
